import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link, useParams, useHistory } from "react-router-dom";
import { motion } from "framer-motion";
import {
  FaUser,
  FaLock,
  FaRegEnvelope,
  FaPhone,
  FaEye,
  FaEyeSlash,
} from "react-icons/fa";
import { useDataContext } from "../Context/dataContext";
import logo from "../Assets/Images/remesalogo.png";
import registerImage from "../Assets/Images/loginn.jpg"; // Usa misma imagen que login
import { Input } from "reactstrap"; // Asegúrate de que este componente esté correctamente importado

function Register() {
  const history = useHistory();
  const { url } = useDataContext();
  const [use_phonePrefix, setUse_phonePrefix] = useState("+34"); // Prefijo por defecto
  const [use_phone, setUse_phone] = useState("");
  const { ref } = useParams();

  // Estados para mostrar/ocultar contraseña
  const [showPassword, setShowPassword] = useState(false);
  const [showReferral, setShowReferral] = useState(false);
  const [loading, setLoading] = useState(false);

  // Estados para el formulario
  const [use_name, setUse_name] = useState("");
  const [use_lastName, setUse_lastName] = useState("");
  const [use_email, setUse_email] = useState("");
  const [use_password, setUse_password] = useState("");
  const [use_referredById, setUse_referredById] = useState("");

  // Sincroniza el estado con el parámetro ref si existe
  useEffect(() => {
    if (ref) {
      setUse_referredById(ref);
    }
  }, [ref]);
  const [use_confirm, setUse_confirm] = useState("");
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [privacyAccepted, setPrivacyAccepted] = useState(false);
  const [errors, setErrors] = useState({});
  const [errorMsg, setErrorMsg] = useState("");

  const clearError = (field) => {
    setErrors((prev) => ({
      ...prev,
      [field]: "",
    }));
  };



  const validateForm = () => {
    const newErrors = {};

    // Nombre
    if (!use_name.trim()) {
      newErrors.use_name = "El nombre es obligatorio";
    }

    // Apellido
    if (!use_lastName.trim()) {
      newErrors.use_lastName = "El apellido es obligatorio";
    }

    // Email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!use_email.trim()) {
      newErrors.use_email = "El correo es obligatorio";
    } else if (!emailRegex.test(use_email)) {
      newErrors.use_email = "El correo no es válido";
    }

    // Teléfono
    if (!use_phone) {
      newErrors.use_phone = "El teléfono es obligatorio";
    } else if (use_phone.length < 7) {
      newErrors.use_phone = "El teléfono es demasiado corto";
    }

    // Contraseña
    if (!use_password) {
      newErrors.use_password = "La contraseña es obligatoria";
    } else if (use_password.length < 8) {
      newErrors.use_password =
        "La contraseña debe tener al menos 8 caracteres";
    }

    // Confirmación
    if (use_password !== use_confirm) {
      newErrors.use_confirm = "Las contraseñas no coinciden";
    }

    // Términos
    if (!termsAccepted) {
      newErrors.termsAccepted =
        "Debes aceptar los términos y condiciones";
    }

    if (!privacyAccepted) {
      newErrors.privacyAccepted =
        "Debes aceptar la política de privacidad";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };




  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    setLoading(true);
    setErrorMsg("");

    try {
      await axios.post(`${url}/Auth/register`, {
        use_name,
        use_lastName,
        use_dni: "",
        use_email: use_email.toLowerCase(),
        use_password: use_password.toLowerCase(),
        use_verif: "N",
        use_img: "",
        use_phone: `${use_phonePrefix}${use_phone}`,
        use_referredById,
      });

      await axios.post(`${url}/Mailer/EmailWelcome/${use_email}`);

      history.push("/Login");
    } catch (error) {
      setErrorMsg(error.response?.data?.message || "Error en el registro");
    } finally {
      setLoading(false);
    }
  };


  return (
    <div className="register-page">
      {errorMsg && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(0,0,0,0.3)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              background: "#fff",
              padding: "2rem 2.5rem",
              borderRadius: "16px",
              boxShadow: "0 2px 16px rgba(0,0,0,0.15)",
              textAlign: "center",
              minWidth: "300px",
            }}
          >
            <div
              style={{
                fontSize: "3rem",
                color: "#ff9800",
                marginBottom: "1rem",
              }}
            >
              ⚠️
            </div>
            <div style={{ fontWeight: "bold", marginBottom: "0.5rem" }}>
              ¡Advertencia!
            </div>
            <div>{errorMsg}</div>
            <button
              style={{
                marginTop: "1.5rem",
                padding: "0.5rem 1.5rem",
                borderRadius: "8px",
                border: "none",
                background: "#ff9800",
                color: "#fff",
                fontWeight: "bold",
                cursor: "pointer",
              }}
              onClick={() => setErrorMsg("")}
            >
              Cerrar
            </button>
          </div>
        </div>
      )}
      <div className="register-container">
        <div className="register-image">
          <img src={registerImage} alt="Imagen de registro" />
        </div>

        <motion.div
          className="register-form-wrapper"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <Link to="/">
            <motion.img
              src={logo}
              alt="Remesa España"
              className="register-logo"
              whileHover={{ scale: 1.05 }}
              transition={{ duration: 0.3 }}
            />
          </Link>

          <form className="register-form" onSubmit={handleSubmit}>
            <label>
              <FaUser className="icon" />
              <input
                type="text"
                name="name"
                placeholder="Nombre"
                value={use_name}
                onChange={(e) => {
                  setUse_name(e.target.value);
                  clearError("use_name");
                }}
                required

              />
            </label>

            <label>
              <FaUser className="icon" />
              <input
                type="text"
                name="lastName"
                placeholder="Apellido"
                value={use_lastName}
                onChange={(e) => {
                  setUse_lastName(e.target.value);
                  clearError("use_lastName");
                }} required
              />
            </label>

            <label>
              <FaRegEnvelope className="icon" />
              <input
                type="email"
                name="email"
                placeholder="Correo electrónico"
                value={use_email}
                onChange={(e) => {
                  setUse_email(e.target.value);
                  clearError("use_email");
                }} required
              />
            </label>
            {errors.use_email && (
              <small className="error-text">{errors.use_email}</small>
            )}


            <label>
              <FaPhone className="icon" />
              <div className="d-flex phone-container">
                <Input
                  type="select"
                  name="phonePrefix"
                  id="phonePrefix"
                  value={use_phonePrefix}
                  onChange={(e) => setUse_phonePrefix(e.target.value)}
                  className="phone-prefix"
                >
                  <option value="+34">🇪🇸 (+34)</option>
                  <option value="+58">🇻🇪 (+58)</option>
                  <option value="+1">🇺🇸 (+1)</option>
                  <option value="+49">🇩🇪 (+49)</option>
                  <option value="+33">🇫🇷 (+33)</option>
                  <option value="+39">🇮🇹 (+39)</option>
                  <option value="+351">🇵🇹 (+351)</option>
                  <option value="+32">🇧🇪 (+32)</option>
                  <option value="+44">🇬🇧 (+44)</option>
                  <option value="+31">🇳🇱 (+31)</option>
                  <option value="+46">🇸🇪 (+46)</option>
                  <option value="+47">🇳🇴 (+47)</option>
                  <option value="+45">🇩🇰 (+45)</option>
                  <option value="+358">🇫🇮 (+358)</option>
                  <option value="+420">🇨🇿 (+420)</option>
                  <option value="+421">🇸🇰 (+421)</option>
                  <option value="+48">🇵🇱 (+48)</option>
                  <option value="+43">🇦🇹 (+43)</option>
                  <option value="+386">🇸🇮 (+386)</option>
                  <option value="+385">🇭🇷 (+385)</option>
                  <option value="+36">🇭🇺 (+36)</option>
                  <option value="+371">🇱🇻 (+371)</option>
                  <option value="+370">🇱🇹 (+370)</option>
                  <option value="+423">🇱🇮 (+423)</option>
                  <option value="+372">🇪🇪 (+372)</option>
                  <option value="+356">🇲🇹 (+356)</option>
                  <option value="+389">🇲🇰 (+389)</option>
                  <option value="+381">🇷🇸 (+381)</option>
                  <option value="+382">🇲🇪 (+382)</option>
                  <option value="+90">🇹🇷 (+90)</option>
                  <option value="+7">🇷🇺 (+7)</option>
                  <option value="+54">🇦🇷 (+54)</option>
                  <option value="+55">🇧🇷 (+55)</option>
                  <option value="+56">🇨🇱 (+56)</option>
                  <option value="+57">🇨🇴 (+57)</option>
                  <option value="+593">🇪🇨 (+593)</option>
                  <option value="+52">🇲🇽 (+52)</option>
                  <option value="+507">🇵🇦 (+507)</option>
                  <option value="+51">🇵🇪 (+51)</option>
                </Input>

                <input
                  className="m-2"
                  type="text"
                  name="phone"
                  id="phone"
                  placeholder="Teléfono"
                  value={use_phone}
                  onChange={(e) => {
                    const phoneValue = e.target.value.replace(/\D/g, "");
                    setUse_phone(phoneValue);
                    clearError("use_phone");
                  }}
                  required
                />
              </div>
            </label>
            {errors.use_phone && (
              <small className="error-text">{errors.use_phone}</small>
            )}


            <label>
              <FaLock className="icon" />
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                placeholder="Contraseña"
                value={use_password}
                onChange={(e) => {
                  setUse_password(e.target.value);
                  clearError("use_password");
                }}
                required
              />
              <button
                type="button"
                className="toggle-password"
                onClick={() => setShowPassword(!showPassword)}
                aria-label="Mostrar contraseña"
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </button>
            </label>
            {errors.use_password && (
              <small className="error-text">{errors.use_password}</small>
            )}


            <label>
              <FaLock className="icon" />
              <input
                type={showPassword ? "text" : "password"}
                name="confirm"
                placeholder="Confirmar contraseña"
                value={use_confirm}
                onChange={(e) => {
                  setUse_confirm(e.target.value);
                  clearError("use_confirm");
                }} required
              />
              <button
                type="button"
                className="toggle-password"
                onClick={() => setShowPassword(!showPassword)}
                aria-label="Mostrar contraseña"
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </button>
            </label>
            {errors.use_confirm && (
              <small className="error-text">{errors.use_confirm}</small>
            )}


            {/* Dropdown código referido */}
            <div className="dropdown-referral">
              <button
                type="button"
                className="dropdown-toggle"
                onClick={() => setShowReferral(!showReferral)}
                aria-expanded={showReferral}
              >
                ¿Tienes código de referido?
              </button>

              <div
                className={`dropdown-content ${showReferral || ref ? "show" : ""
                  }`}
              >
                <input
                  type="text"
                  placeholder="Código de referido (opcional)"
                  name="referral"
                  value={use_referredById}
                  onChange={(e) => setUse_referredById(e.target.value)}
                />
                <small className="note">
                  Conoce los beneficios de ser referido en nuestra sección de{" "}
                  <a
                    href="/BeneficiosReferido"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    referencias
                  </a>
                  .
                </small>
              </div>
            </div>

            {/* Términos y privacidad */}
            <div className="register-terms">
              <input
                type="checkbox"
                checked={termsAccepted}
                onChange={() => {
                  setTermsAccepted(!termsAccepted);
                  clearError("termsAccepted");
                }} />
              <span>
                Acepto los{" "}
                <a
                  href="/TermsAndConditions"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Términos y Condiciones
                </a>
              </span>
              {errors.termsAccepted && (
  <small className="error-text">{errors.termsAccepted}</small>
)}

            </div>

            <div className="register-terms">
              <input
                type="checkbox"
                checked={privacyAccepted}
                onChange={() => {
                  setPrivacyAccepted(!privacyAccepted);
                  clearError("privacyAccepted");
                }} />
                
              <span>
                Acepto la{" "}
                <a href="/Privacy" target="_blank" rel="noopener noreferrer">
                  Política de Privacidad  
                </a>
                {errors.privacyAccepted && (
  <small className="error-text">{errors.privacyAccepted}</small>
)}
              </span>
              

            </div>

            {/* Botón de envío */}
            <button
              type="submit" 
              className="register-button"
              disabled={loading}
            >
              {loading ? "Registrando..." : "Registrarme"}
            </button>


            <Link to="/Login" className="register-back">
              ¿Ya tienes cuenta? Inicia sesión
            </Link>
          </form>
        </motion.div>
      </div>
    </div>
  );
}

export { Register };
